import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { motion } from "framer-motion";

const AlertCard = ({ title }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
      }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}>
        <Card
          sx={{
            p: 4,
            maxWidth: 450,
            backgroundColor: "#ffebee", // Light red background
            color: "#c62828", // Dark red text
            textAlign: "center",
            boxShadow: 3,
            borderRadius: 3,
          }}>
          <CardContent>
            <Typography variant="h5" fontWeight="bold">
              ⚠️ No {title} Found.
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              No {title} is associated with this Learner. Please check with your
              administrator.
            </Typography>
          </CardContent>
        </Card>
      </motion.div>
    </Box>
  );
};

export default AlertCard;
